<template>
  <div>
    <div style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
      <div style="font-size: 40px;margin-top: 20px;">打分测评小程序-打分表制作平台</div>
      <div style="font-size: 18px;margin-top: 10px;">*绩效考核、民主测评、自评互评！*</div>
    </div>
    <div class="loginFormStyle">
      <div class="loginRowStyle">
        <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">

          <div class="columnStyle">
            <!--            <el-carousel :interval="4000" type="card" height="450px">
              <el-carousel-item v-for="(image,index) in images" :key="index">
                <div style="display: flex;justify-content: center;">
                  <el-image style="width:250px;" :src="images[index]" fit="scale-down"></el-image>
                </div>
              </el-carousel-item>
            </el-carousel> -->
            <img src="/evaluations/hompage_images/p1.jpg" />
          </div>
          <!-- <div style="text-align: center;">查询条件可定义,简单易用！</div> -->
        </div>
        <div>
          <el-card class="box-card">
            <div slot="header" class="clearfix titleBoxStyle">
              <div>
                <div style="font-size: 20px;font-weight: bold;" align="center">打分测评小程序扫码登录</div>
              </div>
            </div>
            <div>
              <div>
                <div style="color:red;text-align: center;font-size: 16px;">请尽量用手机端微信，功能更好用更完整！</div>
                <div style="margin: 10px;text-align: center;margin-top: 20px;">
                  <el-button style="color:black;font-size: 18px;" @click="scanLogin()" type="warning">点我打开登录窗口
                  </el-button>
                </div>
                <div style="margin-top: 30px;">
                  <div style="font-weight: bold;font-size: 18px;">登录步骤：</div>
                  <div style="margin-top: 20px;">
                    <div style="word-wrap:break-word;font-size: 14px;margin-top: 20px;font-size: 16px;">1.点击上面按钮会弹出显示方形二维码的窗口;</div>
                    <div style="word-wrap:break-word;font-size: 14px;margin-top: 20px;font-size: 16px;">2.打开<span style="font-weight: bold;">打分测评小程序</span>，点“如何使用”页面上的"扫码登录电脑端"扫方形二维码登录.</div>
                  </div>

                </div>
              </div>

              <el-row class="registerStyle" style="margin-top: 20px;">
                <el-button @click="howToSwitch" type="text" size="medium">
                  扫码失败怎么办?请切换浏览器模式!
                </el-button>
              </el-row>

            </div>
          </el-card>
        </div>
      </div>

    </div>
    <div>
      <div style="text-align: center;margin-top: 20px;font-size: 16px;"><span @click="testLogin"
          style="text-decoration:underline;">测试入口</span><span style="padding-left:10px;">客服微信:wx34424698</span><span
          style="padding-left:10px;">客服QQ:34424698</span>
<!--        <div style="padding-top:10px;font-size: 14px;">兰州新区智韬科技有限公司 备案号:<a href="https://beian.miit.gov.cn"
            target="_blank">陇ICP备19004729号-8</a></div> -->
      </div>

      <div style="padding-top:10px;font-size: 14px;display: flex;justify-content: center;align-items: center;margin-bottom: 50px;">
        <span>智韬科技</span>
        <span style="margin-left:20px;display: flex;justify-content: center;align-items: center;">ICP备案号:<a
            href="https://beian.miit.gov.cn" target="_blank">陇ICP备19004729号</a></span>
        <span style="margin-left:20px;display: flex;justify-content: center;align-items: center;">
          <img src="http://www.hedui.top/evaluations/images/gongan_beian_logo.png" style="width:20px;height:20px;" />
          <a href="https://beian.mps.gov.cn/#/form/webSearch?code=62010202004356" rel="noreferrer"
            target="_blank">甘公网安备62010202004356号</a>
        </span>
      </div>
    </div>

    <!--模式切换帮助-->
    <el-dialog width="80%" :close-on-click-modal="false" title="如何切换浏览器的模式" :visible.sync="browserSwitchDialogVisible">
      <div class="colStyle">
        如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"
        <br /><br />
        <img src="../assets/switch_browser.png" width="100%" />
        <br /><br />
        正确的应该是如下图所示：
        <br /><br />
        <img src="../assets/good_browser.png" width="100%" />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="browserSwitchDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!--扫码登录-->
    <el-dialog width="60%" :close-on-click-modal="false" title="扫码登录(手机端小程序功能更丰富,请尽量使用手机端)" :visible.sync="scanLoginDialogVisible"
      :before-close="beforeClose">
      <div style="display: flex;justify-content: center;align-items: center;">
        <div style="margin: 10px;">
          <div style="text-align: center;font-weight: bold;">第一步:用微信打开“打分测评”</div>
          <div><img src="/evaluations/images/dfcp_qrcode.jpg" style="width: 200px;height: 200px;" /></div>

        </div>
        <div style="width: 50%;">
          <div style="margin-top: 5px;">用<span style="color:red;">打分测评微信小程序</span>“<span
              style="font-weight: bold;font-size: 18px;">更多功能</span>”中的“<span
              style="font-weight: bold;font-size: 18px;">扫码登录电脑端</span>”扫右侧的二维码登录.</div>
          <div style="margin-top: 20px;color: red;">如果扫码后无法登录，请将当前浏览器切换为"高速模式"或"极速速模式"模式后再扫码。</div>
          <div style="margin-top: 20px;color: red;">
            <el-button @click="howToSwitch" type="text" size="medium">
              如何将浏览器切换成"高速模式"或"极速速模式"
            </el-button>
          </div>
        </div>


        <div style="margin: 10px;">
          <div style="text-align: center;font-weight: bold;">第二步:用打分测评“扫码登录”</div>
          <div><img :src="login_qrcode_url" style="width: 200px;height: 200px;" /></div>

        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeScan">关闭</el-button>
      </div>
    </el-dialog>

    <!--扫码下载文件-->
    <!-- <el-dialog width="40%" :close-on-click-modal="false" title="扫码下载文件" :visible.sync="scanDownloadDialogVisible"
      :before-close="beforeClose">

      <div style="display: flex;justify-content: center;align-items: center;">
        <div style="width: 50%;">
          <div>要下载哪个表格,就在“导出excel”成功提示的页面上,点“扫码用电脑下载”扫描右侧的二维码下载。</div>
          <div style="margin-top: 20px;color: red;">如果扫码后无法下载，请刷新当前网页后再扫码。</div>
        </div>

        <div>
          <img :src="download_qrcode_url" style="width: 200px;height: 200px;" />
        </div>
      </div>

      <div v-show="download_file_url" style="margin-left: 20px;">
        <div style="font-size: 18px;font-weight: bold;">传输成功,请点击下面的链接下载文件！</div>
        <div>{{download_file_url}}</div>
        <div>
          <el-button @click="downloadFile()" type="success">立即下载文件</el-button>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDownload">关闭</el-button>
      </div>
    </el-dialog> -->

    <!--测试登录-->
    <el-dialog width="30%" :close-on-click-modal="false" title="测试登录" :visible.sync="testDialogVisible"
      :before-close="beforeClose">
      <div style="display: flex;justify-content: left;align-items: center;">

        <el-form :model="loginForm" status-icon ref="loginForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="手机号" prop="username">
            <el-input type="text" v-model="loginForm.username" autocomplete="off" placeholder="输入手机号,和手机端相同">
            </el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="loginForm.password" @keyup.enter.native="submitForm('loginForm')"
              autocomplete="off" placeholder="输入密码,和手机端相同"></el-input>
          </el-form-item>

        </el-form>

      </div>

      <div slot="footer" class="dialog-footer">
        <div style="display: flex;justify-content: center;">
          <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
          <el-button @click="cancelTestLogin">取消</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        browserSwitchDialogVisible: false,
        loginForm: {
          username: '',
          password: '',
          qrcode_url: '/evaluations/web/_qrcode.jsp'
        },

        images: [
          '/evaluations/hompage_images/p1.png'
        ],

        scanLoginDialogVisible: false,
        timer: null,

        scanDownloadDialogVisible: false,
        showDownloadLink: false,
        download_file_url: '',
        login_qrcode_url: '/evaluations/web/_qrcode.jsp',
        download_qrcode_url: '/evaluations/web/_download_qrcode.jsp',

        testDialogVisible: false
      }
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    created() {
      this.$session.set('USERNAME', '') // 存session
      this.$session.set('NAME', '') // 存session
    },
    methods: {
      submitForm(formName) {
        let that = this

        if (this.loginForm.username === '') {
          that.$message.error('请输入手机号')
          return
        }

        if (this.loginForm.password === '') {
          that.$message.error('请输入密码')
          return
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_login.jsp'

        this.axios.get(requestUrl, {
            params: {
              username: that.loginForm.username,
              password: that.loginForm.password
            }
          }).then(function(response) {
            console.log(response.data.result)
            var result = response.data.result
            if (result === '0') {
              that.$session.set('USERNAME', that.loginForm.username) // 存session
              that.$session.set('NAME', response.data.name) // 存session

              // that.$router.push('/exam_list')

              that.$router.push({
                path: '/form_list',
                params: {
                  username: that.loginForm.username
                }
              })
            } else {
              var tip = response.data.password_tip
              if (tip === '') {
                that.$message.error('账号错误,登录失败！')
              } else {
                that.$message.error('密码错误,登录失败！密码提示:' + tip)
              }
            }

            load.close()
          })
          .catch(err => {
            that.$message.error('登录失败，网络异常请稍后重试！')
            console.log(err)
            load.close()
          })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
      registe() {
        // this.$router.push('/registe')
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      },
      enterFun() {

        // this.submitForm('loginForm')
      },
      forgotPassword() {
        this.$message.error('请用手机端多人填表小程序查看密码!')
      },
      scanLogin() {
        let that = this

        var timestamp = new Date().getTime()

        this.login_qrcode_url = this.login_qrcode_url + '?t=' + timestamp

        this.timer = setInterval(function() {
          // console.log(this.timer)

          // 执行内容this.timer
          var requestUrl = '/evaluations/web/_form_login_state.jsp'

          that.axios.get(requestUrl, {
            params: {}
          }).then(function(res) {
            var usr = res.data.username

            if (res.data.result === '1') {
              that.$session.set('USERNAME', usr)
              clearInterval(that.timer)

              that.$router.push({
                path: '/form_list',
                params: {
                  username: usr
                }
              })
            } else {}
          })
        }, 1000)
        this.scanLoginDialogVisible = true
      },
      closeScan() {
        clearInterval(this.timer)
        this.scanLoginDialogVisible = false
      },
      beforeClose() {
        this.closeScan()
      },
      scanDownload() {
        let that = this

        var timestamp = new Date().getTime()

        this.download_qrcode_url = this.download_qrcode_url + '?t=' + timestamp

        this.timer = setInterval(function() {
          // console.log(this.timer)

          // 执行内容this.timer
          var requestUrl = '/evaluations/web/_form_download_state.jsp'

          that.axios.get(requestUrl, {
            params: {}
          }).then(function(res) {
            if (res.data.result === '1') {
              var download_file_url = res.data.download_file_url
              clearInterval(that.timer)

              that.download_file_url = download_file_url

              this.$message.success('文件已经传输成功，请点下载文件按钮下载！')

              console.log(download_file_url)

              // that.$router.push({
              //   path: '/download_file',
              //   params: {
              //     username: usr
              //   }
              // })
            } else {}
          })
        }, 1000)
        this.download_file_url = ''
        this.scanDownloadDialogVisible = true
      },
      closeDownload() {
        clearInterval(this.timer)
        this.scanDownloadDialogVisible = false
      },
      downloadFile() {
        window.open(this.download_file_url)
      },
      testLogin() {
        console.log('*******')
        this.testDialogVisible = true
      },
      cancelTestLogin() {
        this.testDialogVisible = false
      }

    }
  }
</script>

<style>
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 480px;
  }

  .loginFormStyle {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  .titleBoxStyle {
    display: flex;
    justify-content: center;
  }

  .titleBoxStyle span {
    font-size: 30px;
    font-weight: bold;
  }

  .btnActionStyle {
    display: flex;
    justify-content: center;
  }

  .registerStyle {
    display: flex;
    justify-content: center;
  }

  .loginRowStyle {
    display: flex;

  }

  .imageRowStyle {
    display: flex;
    flex-direction: row;
  }

  .columnStyle {
    display: flex;
    flex-direction: column;
    width: 800px;
    height: 500px;
    margin-right: 20px;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue